import React, { useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import cx from 'classnames';

// TODO Review use of this class by reading https://lets-do-this.atlassian.net/browse/LDS-42
import { GLOBAL_FORM_STYLES_CLASS } from '@/globalClasses';

import { getAutofillString } from '../utils';
import FieldWrapper from './FieldWrapper';
import Help from './Help';

import {
  text,
  inputWrapper,
  inputWithIcon,
  iconContainer,
} from '../styles.module.css';

export const BaseInput = (props) => {
  const { register } = useFormContext();
  const inputRef = useRef(null);
  const {
    autoFocus = false,
    id,
    required = false,
    type = 'text',
    validation,
    onChange = () => {},
    value,
    placeholder,
    className,
    title,
    disabled,
    help,
    isTextArea,
    step,
    wrapperClassName,
    rightIcon,
    rows,
    onFocus = () => {},
    defaultValue,
  } = props;
  const InputElement = isTextArea ? 'textarea' : 'input';
  const icon = (help && <Help>{help}</Help>) || rightIcon;
  const focusInput = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div
      className={cx(inputWrapper, wrapperClassName, GLOBAL_FORM_STYLES_CLASS)}
    >
      <InputElement
        name={id}
        className={cx(className, text, !!icon && inputWithIcon)}
        autoComplete={getAutofillString(id)}
        ref={(e) => {
          inputRef.current = e;
          register(e, {
            required: required && `${title} required`,
            ...validation,
          });
        }}
        {...{
          id,
          value,
          type,
          placeholder,
          step,
          rows,
          onChange,
          onFocus,
          autoFocus,
          disabled,
          defaultValue,
        }}
      />
      {!!icon && (
        <div
          className={iconContainer}
          onClick={focusInput}
          onKeyPress={focusInput}
        >
          {icon}
        </div>
      )}
    </div>
  );
};

const Input = (props) => {
  return (
    <FieldWrapper {...props}>
      <BaseInput {...props} />
    </FieldWrapper>
  );
};

export default Input;
